/*
this directive is made to change the drag property from p-dialog component to be dragged only on screen
*/

import { AfterContentInit, Directive, ElementRef, Input, HostListener } from "@angular/core";

import { BfxDocumentMouseEnterService } from "../../bfx-common/services/bfx-document-mouseenter.service";
import { BfxDocumentMouseLeaveService } from "../../bfx-common/services/bfx-document-mouseleave.service";

@Directive({
  selector: "[draggableDialog]",
  standalone: false,
})
export class DraggableDialog implements AfterContentInit {
  @Input("draggableDialog")
  dialog = null;

  private mouseleave = false;
  private mousedownOnEnter = false;
  private draggingOnMouseleave = false;
  private pendingStopDragging = false;

  constructor(
    _enterService: BfxDocumentMouseEnterService,
    _leaveService: BfxDocumentMouseLeaveService,
  ) {
    _leaveService.$documentMouseLeave.subscribe(($event: MouseEvent) => {
      this.mouseleave = true;
    });

    _enterService.$documentMouseEnter.subscribe(($event: MouseEvent) => {
      if (this.mouseleave) {
        this.mousedownOnEnter = ($event.buttons & 1) === 1;
      }
    });
  }

  public ngAfterContentInit() {
    this.dialog["__bfx_draggable-dialog-directive"] = this;

    this.dialog.onDrag = function (event) {
      const dragDirective = this["__bfx_draggable-dialog-directive"];

      if (dragDirective.pendingMouseLeave) {
        dragDirective.handleMouseLeave();
      } else if (dragDirective.pendingMouseEnter) {
        dragDirective.handleMouseEnter();
      }

      if (dragDirective.pendingStopDragging) {
        dragDirective.stopDragging();
      }

      if (this.dragging) {
        var deltaX = event.pageX - this.lastPageX;
        var deltaY = event.pageY - this.lastPageY;
        var leftPos = parseInt(this.container.style.left);
        var topPos = parseInt(this.container.style.top);
        // min position of dialog window top and bottom
        var MIN_POS = { y: 0, b: 30 };
        this.container.style.left =
          Math.max(0, Math.min(window.innerWidth - this.container.offsetWidth, leftPos + deltaX)) +
          "px";
        this.container.style.top =
          Math.max(MIN_POS.y, Math.min(window.innerHeight - MIN_POS.b, topPos + deltaY)) + "px";
        this.lastPageX = event.pageX;
        this.lastPageY = event.pageY;
      }
    }.bind(this.dialog);
  }

  /**
   * Not needed on desktop, and has no effect.
   * However it gets triggered on desktop on any mouse drag on the blotters (main window) when there is a dialog open (again no effect).
   */
  @HostListener("document:mouseup", ["$event"])
  public onMouseUp(event: MouseEvent) {
    if (this.dialog.dragging) {
      this.pendingStopDragging = true;
    }
  }

  private handleMouseLeave(): void {
    this.dialog.dragging = false;
    this.mouseleave = false;
    this.draggingOnMouseleave = true;
  }

  private handleMouseEnter(): void {
    this.dialog.dragging = true;
    this.mouseleave = false;
    this.draggingOnMouseleave = false;
    this.mousedownOnEnter = false;
  }

  private stopDragging(): void {
    this.dialog.dragging = false;
    this.pendingStopDragging = false;
  }

  private get pendingMouseLeave(): boolean {
    return this.dialog.dragging && this.mouseleave;
  }

  private get pendingMouseEnter(): boolean {
    return !this.dialog.dragging && this.draggingOnMouseleave && this.mousedownOnEnter;
  }
}
